import React, { useMemo, useState } from 'react'

import { chunk } from 'lodash-es'
import { useTranslation } from 'next-i18next'
import { Button } from '../ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

const SlotsPanel = ({
  availableSlots,
  selectedSlot,
  onSlotChanged,
  openHours,
}: {
  availableSlots: string[]
  selectedSlot: string | undefined
  onSlotChanged: (slot: string) => void
  openHours?: { startsTime: string; displayTime?: string }[]
}) => {
  const [page, setPage] = useState(0)
  const { t } = useTranslation('experience')

  const getDisplayTime = (slot: string) => {
    if (!openHours) return slot
    const openHour = openHours.find((oh) => oh.startsTime === slot)
    return openHour?.displayTime || slot
  }

  const slotsPaginator = useMemo(
    () => chunk(availableSlots, 32),
    [availableSlots]
  )

  return (
    <div className="flex items-center w-full">
      <div>
        {page > 0 && (
          <Button
            onClick={() => setPage(page - 1)}
            disabled={page === 0}
            type="button"
            size="icon"
            variant="ghost"
          >
            <ChevronLeft />
          </Button>
        )}
      </div>
      <div className="flex flex-wrap justify-center flex-grow text-sm">
        <span className="">
          {availableSlots.length === 0 && t('no_available_slots')}
        </span>

        {slotsPaginator[page]?.map((slot) => (
          <div
            key={slot}
            className={cn(
              'mx-1 my-1 cursor-pointer border-1 rounded-full py-1 text-small bg-gray-300 border-gray-300 flex justify-center items-center px-2',
              {
                'border-primar bg-primary text-white': slot === selectedSlot,
              }
            )}
            onClick={() => onSlotChanged(slot)}
          >
            {getDisplayTime(slot)}
          </div>
        ))}
      </div>
      <div>
        {page < slotsPaginator.length - 1 && (
          <Button
            onClick={() => setPage(page + 1)}
            disabled={page === slotsPaginator.length - 1}
            type="button"
            size="icon"
            variant="ghost"
          >
            <ChevronRight />
          </Button>
        )}
      </div>
    </div>
  )
}

export default SlotsPanel
